import { Link, useLocation } from "react-router-dom";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname === "/admin") return null;
  return (
    <footer className="relative mt-24 bg-[#121A16] text-[#F5F0EB]">
      <div className="jt-container py-16 grid gap-10 md:grid-cols-4">
        <div>
          <img src="/logo-light.png" alt="JawaiTrails.com" className="h-16 w-auto mb-2" data-testid="footer-logo"/>
          <p className="text-xs tracking-wide text-[#D4A359] mb-4" data-testid="footer-parent-company">A unit of Alex Hospitality Services</p>
          <p className="text-sm text-[#B3BDB6] leading-relaxed">The definitive marketplace for leopard safaris and luxury stays in Jawai, Rajasthan.</p>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-[#B3BDB6]">
            <li><Link to="/safaris" className="hover:text-white">All Safaris</Link></li>
            <li><Link to="/experiences" className="hover:text-white">Experiences</Link></li>
            <li><Link to="/blog" className="hover:text-white" data-testid="footer-blog">Jawai Journal</Link></li>
            <li><Link to="/stays" className="hover:text-white">Hotels & Stays</Link></li>
            <li><Link to="/packages" className="hover:text-white">Stay + Safari Packages</Link></li>
            <li><Link to="/book" className="hover:text-white">Book a Safari</Link></li>
            <li><Link to="/lookup" className="hover:text-white">Find My Booking</Link></li>
            <li><Link to="/about" className="hover:text-white">About Jawai</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-3">Policies</h4>
          <ul className="space-y-2 text-sm text-[#B3BDB6]">
            <li><Link to="/policies/cancellation" className="hover:text-white" data-testid="footer-policy-cancellation">Cancellation Policy</Link></li>
            <li><Link to="/policies/terms" className="hover:text-white" data-testid="footer-policy-terms">Terms of Service</Link></li>
            <li><Link to="/policies/privacy" className="hover:text-white" data-testid="footer-policy-privacy">Privacy Policy</Link></li>
            <li><Link to="/policies/code-of-conduct" className="hover:text-white" data-testid="footer-policy-conduct">Operator Code of Conduct</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-3">Reach us</h4>
          <ul className="space-y-3 text-sm text-[#B3BDB6]">
            <li className="flex items-center gap-2"><Phone size={14}/> <a href="tel:+919375332211" className="hover:text-white" data-testid="footer-phone">+91 93753 32211</a></li>
            <li className="flex items-center gap-2"><Mail size={14}/> info@jawaitrails.com</li>
            <li className="flex items-center gap-2"><MapPin size={14}/> Jawai Bandh, Pali, Rajasthan</li>
            <li className="flex items-center gap-2 text-[#D4A359]"><MessageCircle size={14}/> WhatsApp assistance 24/7</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="jt-container py-5 text-xs text-[#8EA094] flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} JawaiTrails. Original brand — not affiliated with any third party.</span>
          <span>Timezone: Asia/Kolkata</span>
        </div>
      </div>
    </footer>
  );
}
